import { render, staticRenderFns } from "./AlbumPhotoBodyMain.vue?vue&type=template&id=b66f4f60&"
import script from "./AlbumPhotoBodyMain.vue?vue&type=script&lang=js&"
export * from "./AlbumPhotoBodyMain.vue?vue&type=script&lang=js&"
import style0 from "./AlbumPhotoBodyMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b66f4f60')) {
      api.createRecord('b66f4f60', component.options)
    } else {
      api.reload('b66f4f60', component.options)
    }
    module.hot.accept("./AlbumPhotoBodyMain.vue?vue&type=template&id=b66f4f60&", function () {
      api.rerender('b66f4f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Press/AlbumPhotoBodyMain.vue"
export default component.exports